import { SiteTypes } from '../enums';
import { getEndpointURL } from './getEndpointUrl';

export const goToFavouritesList = (listId: string) => {
  globalThis.location.href = getEndpointURL(SiteTypes.FAVOURITES, `list/${listId}`);
};
